export default "__VITE_ASSET__83290714__"